export default __webpack_public_path__ + "static/media/a006-c.75d41127.png";